import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconStarDefault(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={25}
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M12 3c.374 0 .72.2.909.523l2.798 4.805 5.465 1.197a1.058 1.058 0 0 1 .554 1.742l-3.713 4.09.581 5.476c.04.373-.121.738-.422.96a1.05 1.05 0 0 1-1.04.121L12 19.704l-5.132 2.21a1.05 1.05 0 0 1-1.04-.12 1.06 1.06 0 0 1-.422-.961l.581-5.477-3.713-4.09a1.058 1.058 0 0 1 .554-1.741l5.464-1.197 2.8-4.805C11.28 3.2 11.625 3 12 3m0 3.148L9.877 9.793a1.05 1.05 0 0 1-.684.498l-4.135.906 2.805 3.089c.202.223.3.522.268.822l-.441 4.155 3.895-1.678a1.05 1.05 0 0 1 .83 0l3.895 1.678-.44-4.155c-.033-.3.065-.6.268-.822l2.804-3.089-4.135-.905a1.05 1.05 0 0 1-.684-.5z'
          clipRule='evenodd'
        />
      </svg>
    </>
  )
}
IconStarDefault.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconStarDefault
